import { filter } from "lodash";
import { getI18n } from "react-i18next";

import {
  FieldRequestFieldEnum,
  IFieldRequest,
} from "@krea/customer-features/types/fieldRequest";
import { IPromotion } from "@krea/customer-features/types/lenderResponse";
import { FIELD_REQUEST_TYPES } from "@krea/customer-features/utils";
import { PromotionTypeEnum } from "@krea/shared/types/common";

const getUnsubmittedFieldRequests = (
  fieldRequests: IFieldRequest[],
): IFieldRequest[] => {
  return filter(
    fieldRequests,
    ({ isSubmitted, field, type, lenderComment, isCollectedByLender }) => {
      return (
        !isCollectedByLender &&
        (!!lenderComment ||
          (!isSubmitted &&
            type === FIELD_REQUEST_TYPES.ADDITIONAL_INFORMATION) ||
          (!isSubmitted && field === FieldRequestFieldEnum.guarantors))
      );
    },
  );
};

export const getPromotionsAsText = (promotion: IPromotion): string => {
  const { t } = getI18n();
  if (!promotion.value) return ""; // Should never happen, but just in case

  switch (promotion.type) {
    case PromotionTypeEnum.INTEREST_FREE:
      return t("dash.promotions.interest_free", { count: promotion.value });
    case PromotionTypeEnum.AMORTISATION_FREE:
      return t("dash.promotions.amortisation_free", {
        count: promotion.value,
      });
  }
};

export default getUnsubmittedFieldRequests;
